function details(){
    const detailsItems = document.querySelectorAll('.details__item');
    detailsItems.forEach(item => {
        item.addEventListener('click', (e) => {
            if(item.open){
                item.querySelector('.details__summary-svg use').setAttribute("xlink:href", "img/sprite.svg#details-plus");
            } else {
                item.querySelector('.details__summary-svg use').setAttribute("xlink:href", "img/sprite.svg#details-minus");
            }
        });
    });
}

export default details;